import loyaltyProgramConstants from 'constants/loyaltyProgram';

const REGULAR = 'regular';

const TIER_LABELS = {
  [REGULAR]: 'Regular',
  [loyaltyProgramConstants.STATUS_EARLY_ACCESS]: 'Early Access',
  [loyaltyProgramConstants.STATUS_EXCLUSIVE]: 'Xclusive',
};

export const getTierKey = (status) => status || REGULAR;

export const getTierLabel = (status) => TIER_LABELS[getTierKey(status)];

// The backend sends null once there is nothing above Xclusive. What we show
// there is the renewal, so it reads as Xclusive again.
export const getNextTierStatus = (nextStatus) =>
  nextStatus || loyaltyProgramConstants.STATUS_EXCLUSIVE;

export const getNextTierLabel = (nextStatus) => {
  const label = getTierLabel(getNextTierStatus(nextStatus));

  if (nextStatus) {
    return label;
  }

  const nextYear = new Date().getFullYear() + 1;

  return `${label} ${nextYear}`;
};
